export const permissionsKeys = {
    permissions: (search?: string) => ['permissions', search],
    permission: (id: string) => ['permission', id],
};